var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPredictiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_932_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 13.6953V6.30466C17.1869 6.19339 17.157 6.08425 17.1007 5.98824C17.0445 5.89222 16.9639 5.81273 16.8672 5.75779L10.3047 2.04685C10.2121 1.99337 10.107 1.96521 10 1.96521C9.89303 1.96521 9.78795 1.99337 9.69531 2.04685L3.13281 5.75779C3.03606 5.81273 2.9555 5.89222 2.89926 5.98824C2.84302 6.08425 2.8131 6.19339 2.8125 6.30466V13.6953C2.8131 13.8066 2.84302 13.9157 2.89926 14.0117C2.9555 14.1077 3.03606 14.1872 3.13281 14.2422L9.69531 17.9531C9.78795 18.0066 9.89303 18.0347 10 18.0347C10.107 18.0347 10.2121 18.0066 10.3047 17.9531L16.8672 14.2422C16.9639 14.1872 17.0445 14.1077 17.1007 14.0117C17.157 13.9157 17.1869 13.8066 17.1875 13.6953Z",
    stroke: "#4A4D57",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.8125C11.5533 12.8125 12.8125 11.5533 12.8125 10C12.8125 8.4467 11.5533 7.1875 10 7.1875C8.4467 7.1875 7.1875 8.4467 7.1875 10C7.1875 11.5533 8.4467 12.8125 10 12.8125Z",
    stroke: "#4A4D57",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_932_263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictiveIcon);
export default __webpack_public_path__ + "static/media/PredictiveIcon.d27fc1f06e7779873fadabb46d62b8bd.svg";
export { ForwardRef as ReactComponent };